/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetInvoicesZipInvoice
 */
export interface GetInvoicesZipInvoice {
    /**
     * 
     * @type {string}
     * @memberof GetInvoicesZipInvoice
     */
    invoicePdfKey: string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicesZipInvoice
     */
    invoiceIdentifier: string;
}

/**
 * Check if a given object implements the GetInvoicesZipInvoice interface.
 */
export function instanceOfGetInvoicesZipInvoice(value: object): value is GetInvoicesZipInvoice {
    if (!('invoicePdfKey' in value) || value['invoicePdfKey'] === undefined) return false;
    if (!('invoiceIdentifier' in value) || value['invoiceIdentifier'] === undefined) return false;
    return true;
}

export function GetInvoicesZipInvoiceFromJSON(json: any): GetInvoicesZipInvoice {
    return GetInvoicesZipInvoiceFromJSONTyped(json, false);
}

export function GetInvoicesZipInvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvoicesZipInvoice {
    if (json == null) {
        return json;
    }
    return {
        
        'invoicePdfKey': json['invoicePdfKey'],
        'invoiceIdentifier': json['invoiceIdentifier'],
    };
}

  export function GetInvoicesZipInvoiceToJSON(json: any): GetInvoicesZipInvoice {
      return GetInvoicesZipInvoiceToJSONTyped(json, false);
  }

  export function GetInvoicesZipInvoiceToJSONTyped(value?: GetInvoicesZipInvoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoicePdfKey': value['invoicePdfKey'],
        'invoiceIdentifier': value['invoiceIdentifier'],
    };
}

